import { render, staticRenderFns } from "./CallBackRequestCard.vue?vue&type=template&id=c32b38b2&scoped=true"
import script from "./CallBackRequestCard.vue?vue&type=script&lang=js"
export * from "./CallBackRequestCard.vue?vue&type=script&lang=js"
import style0 from "./CallBackRequestCard.vue?vue&type=style&index=0&id=c32b38b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32b38b2",
  null
  
)

export default component.exports